import API from "../api/manager";
import config from "../api/config";
import BOOKING_API from "../api/manager_booking";

const fetchBookings = (query = "") => {
  return API({
    method: "GET",
    url: `${config.urls.bookings.getBookingsDet}${query}`,
  });
};

const fetchBookingById = (id) => {
  return API({
    method: "GET",
    url: `${config.urls.bookings.getBookingsDet}${id}`,
  });
};

const fetchBookingDashboard = () => {
  return API({
    method: "GET",
    url: config.urls.bookings.dashboard,
  });
};

const fetchInvoice = (query = "") => {
  return API({
    method: "GET",
    url: `${config.urls.bookings.invoices}${query}`,
  });
};

const fetchReportsDashboard = (query = "") => {
  return API({
    method: "GET",
    url: `${config.urls.bookings.reports}${query}`,
  });
};

const getBookingsDet = ({ month, year }) => {
  return API({
    method: "GET",
    url: `${config.urls.bookings.getBookingsDet}?month=${month}&year=${year}`,
  });
};

const fetchLatestBookings = () => {
  return API({
    method: "GET",
    url: `${config.urls.bookings.latestBookings}`,
  });
};

const addOnsiteService = (data) => {
  return API({
    method: "POST",
    url: `${config.urls.bookings.addOnsiteService}`,
    data,
  });
};

const capturePayment = (data) => {
  return API({
    method: "POST",
    url: config.urls.bookings.capture_payment,
    data,
  });
};

const captureRoomPayment = (data) => {
  return API({
    method: "POST",
    url: config.urls.bookings.capture_room_payment,
    data,
  });
};

const verifications = (data) => {
  return BOOKING_API(
    {
      method: "POST",
      url: config.urls.auth.verifications,
      data,
    },
    false,
  );
};

const login = (data) => {
  return BOOKING_API(
    {
      method: "POST",
      url: config.urls.auth.sessions,
      data,
    },
    false,
  );
};

const otpLogin = (data) => {
  return BOOKING_API(
    {
      method: "POST",
      url: config.urls.auth.otp_login,
      data,
    },
    false,
  );
};

const validateMobile = (data) => {
  return BOOKING_API(
    {
      method: "POST",
      url: config.urls.auth.validate_mobile,
      data,
    },
    false,
  );
};

const hearingBooking = (data) => {
  return BOOKING_API(
    {
      method: "POST",
      url: config.urls.bookings.book_room,
      data,
    },
    false,
  );
};

const fetchAvailableRooms = (query) => {
  return API(
    { method: "GET", url: config.urls.bookings.availableSlots + query },
    false,
  );
};

const cancelBooking = (data) => {
  return API({
    method: "POST",
    url: config.urls.bookings.cancel_booking,
    data,
  });
};

const rescheduleBooking = (data) => {
  return API({
    method: "POST",
    url: config.urls.bookings.reschedule_booking,
    data,
  });
};

const quitPaymentService = (data) => {
  return API({
    method: "POST",
    url: config.urls.bookings.cancel_pending_reservation,
    data,
  });
};

const captureReschedulePayment = (data) => {
  return API({
    method: "POST",
    url: `${config.urls.bookings.reschedule_booking}/capture-payment`,
    data,
  });
};

const confirmRescheduleRefund = (data) => {
  return API({
    method: "POST",
    url: `${config.urls.bookings.reschedule_booking}/confirm-refund`,
    data,
  });
};

export default {
  fetchBookings,
  fetchBookingById,
  fetchBookingDashboard,
  fetchInvoice,
  fetchReportsDashboard,
  getBookingsDet,
  fetchLatestBookings,
  addOnsiteService,
  capturePayment,
  captureRoomPayment,
  verifications,
  login,
  otpLogin,
  validateMobile,
  hearingBooking,
  fetchAvailableRooms,
  cancelBooking,
  rescheduleBooking,
  quitPaymentService,
  captureReschedulePayment,
  confirmRescheduleRefund,
};
